import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";

import { List, ListItem, Collapse, ListItemText, makeStyles, Tooltip } from "@material-ui/core";

import userMenuStyle from "assets/jss/components/userMenuStyle";
import cx from "classnames";
import LanguageSelector from "./LanguageSelector";
import Person from "@material-ui/icons/Person";
import avatar_default from "assets/img/default-avatar.png";
import { useTranslation } from "react-i18next";
import PowerSettingsNew from "@material-ui/icons/PowerSettingsNew";
import { useReactOidc } from "@axa-fr/react-oidc-context";
import { useQueryWithErrorHandling } from "hooks/errorHandling";
import { USER_BASIC_INFO } from "features/userMenu/queries";
import { env } from "utils/env";

const useStyles = makeStyles(userMenuStyle);

function UserMenu({ miniActive }) {
  const [openAvatar, setOpenAvatar] = useState(false);
  const [currentMiniActive] = useState(true);
  const classes = useStyles();
  const { t } = useTranslation();

  const openCollapseAvatar = useCallback(
    (e) => {
      setOpenAvatar(!openAvatar);
      e.preventDefault();
    },
    [openAvatar]
  );

  const { data } = useQueryWithErrorHandling(USER_BASIC_INFO);
  const { oidcUser, logout } = useReactOidc();
  const logoutAction = useCallback(
    (e) => {
      e.preventDefault();
      if (typeof logout === "function") logout();
    },
    [logout]
  );

  const itemText =
    classes.itemText +
    " " +
    cx({
      [classes.itemTextMini]: miniActive && currentMiniActive,
    });

  return (
    <div className={classes.user}>
      <div className={classes.photo}>
        <img src={data?.getUserProfile?.picture || avatar_default} className={classes.avatarImg} alt="..." />
      </div>
      <List className={classes.list}>
        <ListItem className={classes.item + " " + classes.userItem}>
          <NavLink
            to={"/"}
            className={classes.itemLink + " " + classes.userCollapseButton}
            onClick={openCollapseAvatar}
          >
            <ListItemText
              primary={data?.getUserProfile?.firstName + " " + data?.getUserProfile?.lastName}
              secondary={
                <b
                  className={classes.caret + " " + classes.userCaret + " " + (openAvatar ? classes.caretActive : "")}
                />
              }
              disableTypography={true}
              className={itemText + " " + classes.userItemText}
            />
          </NavLink>
          <Collapse in={openAvatar} unmountOnExit classes={{ wrapper: classes.collapseWrapper }}>
            <List className={classes.list + classes.collapseList}>
              <Tooltip disableHoverListener={!miniActive} title={t("MyProfile")}>
                <ListItem className={classes.collapseItem}>
                  <NavLink to="/my-profile" className={classes.itemLink}>
                    <span className={classes.collapseItemMini}>
                      <Person />
                    </span>
                    <ListItemText primary={t("MyProfile")} disableTypography={true} className={itemText} />
                  </NavLink>
                </ListItem>
              </Tooltip>
              {oidcUser && env.REACT_APP_USE_CIAM?.toLowerCase() !== "true" && (
                <Tooltip disableHoverListener={!miniActive} title={t("Tooltips.Logout")}>
                  <ListItem className={classes.item}>
                    <NavLink to={"/"} className={classes.itemLink} onClick={logoutAction}>
                      <span className={classes.collapseItemMini}>
                        <PowerSettingsNew />
                      </span>
                      <ListItemText primary={t("Tooltips.Logout")} disableTypography={true} className={itemText} />
                    </NavLink>
                  </ListItem>
                </Tooltip>
              )}
              <ListItem className={classes.selectorItem}>
                <LanguageSelector miniActive={miniActive} />
              </ListItem>
            </List>
          </Collapse>
        </ListItem>
      </List>
    </div>
  );
}

UserMenu.propTypes = {
  miniActive: PropTypes.bool.isRequired,
};

export default UserMenu;
